<nb-card class="no-edge-card mb-0 detalle-mando-card">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal()"
			nbTooltip="Cerrar" nbTooltipPlacement="left">
		</nb-icon>
	</div>

	<nb-card-header class="detalle-header">
		<div class="d-flex align-items-center gap-3">
			<nb-icon icon="keypad-outline" class="header-icon"></nb-icon>
			<div>
				<h4 class="m-0 header-title">Detalle del Mando</h4>
				<span class="header-subtitle" *ngIf="mando">{{mando.idMando}}</span>
			</div>
		</div>
	</nb-card-header>

	<nb-card-body *ngIf="!loading && mando; else loadingTpl">
		<div class="detalle-grid">
			<!-- Estado -->
			<div class="detalle-section">
				<h6 class="section-label">Estado</h6>
				<span class="estado-badge-lg" [style.background]="estadoColors[mando.estado]">
					{{estadoLabels[mando.estado] || 'Desconocido'}}
				</span>
			</div>

			<!-- Batería -->
			<div class="detalle-section">
				<h6 class="section-label">Batería</h6>
				<div class="battery-display">
					<div class="battery-bar-container">
						<div class="battery-bar-fill" [ngClass]="'battery-' + getBatteryLevel(mando.battery)"
							[style.width.%]="mando.battery">
						</div>
					</div>
					<span class="battery-text" [ngClass]="'text-battery-' + getBatteryLevel(mando.battery)">
						{{mando.battery}}%
					</span>
				</div>
			</div>

			<!-- MAC -->
			<div class="detalle-section">
				<h6 class="section-label">Dirección MAC</h6>
				<p class="section-value mono">{{mando.mac || '—'}}</p>
			</div>

			<!-- Colegio -->
			<div class="detalle-section">
				<h6 class="section-label">Colegio</h6>
				<p class="section-value">{{mando.centerName || 'Sin asignar'}}</p>
			</div>

			<!-- Fecha de compra -->
			<div class="detalle-section">
				<h6 class="section-label">Fecha de compra</h6>
				<p class="section-value">{{formatDate(mando.creationDate)}}</p>
			</div>

			<!-- Fecha de entrega -->
			<div class="detalle-section">
				<h6 class="section-label">Fecha de entrega</h6>
				<p class="section-value">{{formatDate(mando.fechaEntrega)}}</p>
			</div>
		</div>

		<hr class="my-3">

		<!-- Grupos asignados -->
		<div class="list-section">
			<h6 class="section-label">
				<nb-icon icon="people-outline"></nb-icon>
				Grupos asignados
				<nb-tag size="tiny" appearance="filled" status="basic" class="ml-2">
					{{mando.groups?.length || 0}}
				</nb-tag>
			</h6>
			<div *ngIf="mando.groups && mando.groups.length > 0; else noGroups">
				<div class="list-item" *ngFor="let group of mando.groups">
					<nb-icon icon="folder-outline" class="list-item-icon"></nb-icon>
					<span>{{group.title}}</span>
					<span class="list-item-id">#{{group.idGroup}}</span>
				</div>
			</div>
			<ng-template #noGroups>
				<p class="empty-list-text">Sin grupos asignados</p>
			</ng-template>
		</div>

		<!-- Estudiantes asignados -->
		<div class="list-section mt-3">
			<h6 class="section-label">
				<nb-icon icon="person-outline"></nb-icon>
				Estudiantes asignados
				<nb-tag size="tiny" appearance="filled" status="basic" class="ml-2">
					{{mando.students?.length || 0}}
				</nb-tag>
			</h6>
			<div *ngIf="mando.students && mando.students.length > 0; else noStudents">
				<div class="list-item" *ngFor="let student of mando.students">
					<nb-icon icon="person-outline" class="list-item-icon"></nb-icon>
					<span>{{student.name}} {{student.surname}}</span>
				</div>
			</div>
			<ng-template #noStudents>
				<p class="empty-list-text">Sin estudiantes asignados</p>
			</ng-template>
		</div>
	</nb-card-body>

	<ng-template #loadingTpl>
		<nb-card-body>
			<div class="loading-state">
				<nb-spinner status="primary" size="large"></nb-spinner>
			</div>
		</nb-card-body>
	</ng-template>
</nb-card>
